import { render, staticRenderFns } from "./indexSouthern.vue?vue&type=template&id=5c6b17c6&scoped=true"
import script from "./indexSouthern.vue?vue&type=script&lang=js"
export * from "./indexSouthern.vue?vue&type=script&lang=js"
import style0 from "./indexSouthern.vue?vue&type=style&index=0&id=5c6b17c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b17c6",
  null
  
)

export default component.exports